import { movies, type Movie } from "@/mocks/movies";

export function getMovieById(id: string): Movie | undefined {
  return movies.find((m) => m.id === id);
}

export function getFeatured(): Movie[] {
  return movies.filter((m) => m.featured);
}

export function getLatest(limit = 8): Movie[] {
  return [...movies].sort((a, b) => b.year - a.year).slice(0, limit);
}

export function getPopular(limit = 6): Movie[] {
  return [...movies].sort((a, b) => b.popularity - a.popularity).slice(0, limit);
}

export interface CatalogQuery {
  genre?: string;
  region?: string;
  year?: string;
  keyword?: string;
  sort?: "latest" | "popular";
}

function matchYear(movieYear: number, value?: string): boolean {
  if (!value) return true;
  if (value === "2020年及以前") return movieYear <= 2020;
  return movieYear === Number(value);
}

export function filterMovies(query: CatalogQuery): Movie[] {
  const kw = query.keyword?.trim().toLowerCase();
  let result = movies.filter((m) => {
    if (query.genre && !m.genres.includes(query.genre)) return false;
    if (query.region && m.region !== query.region) return false;
    if (!matchYear(m.year, query.year)) return false;
    if (kw) {
      const haystack = [m.title, m.director, ...m.cast, ...m.genres, ...m.tags].join(" ").toLowerCase();
      if (!haystack.includes(kw)) return false;
    }
    return true;
  });

  result = result.sort((a, b) =>
    query.sort === "popular" ? b.popularity - a.popularity : b.year - a.year,
  );

  return result;
}

export function getRelated(movie: Movie, limit = 5): Movie[] {
  return movies
    .filter((m) => m.id !== movie.id)
    .map((m) => ({
      movie: m,
      score: m.genres.filter((g) => movie.genres.includes(g)).length * 10 + (m.region === movie.region ? 3 : 0),
    }))
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score || b.movie.popularity - a.movie.popularity)
    .slice(0, limit)
    .map((x) => x.movie);
}

export const PAGE_SIZE = 9;